import React, {useEffect, useState} from "react";
import {
    Alert,
    Box,
    Button,
    Divider,
    Grid,
    IconButton,
    MenuItem,
    Paper,
    Select, Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from "@mui/material";
import {makeStyles} from "@mui/styles";
import PlayersListTable from "../PlayersListTable";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import {useDispatch, useSelector} from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import MainModal from "../../MainModal";
import {getAllCourses} from "../../../redux/actions/courses-action";
import {getMinimalPlayers, submitScores,} from "../../../redux/actions/player-area-action/scores-action";
import {useNavigate} from "react-router-dom";
import {CSVLink} from "react-csv";
import imgCsv from "../../../assets/images/download.png";
import {apiGet} from "../../../utils/apiRequests";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import {toast} from "react-toastify";
import SearchBar from "../../Search";
import {deletePlayer} from "../../../redux/actions/player-area-action/players-action";

const useStyles = makeStyles((theme) => ({
    outlineInputBorder: {
        "& * > fieldset > legend": {
            display: "none",
        },
        "& > fieldset > legend > span": {
            display: "none",
        },
    },
    addIconButton: {
        background: "#2C633C !important",
        height: "30px",
        width: "30px",
    },
    searchBtn: {
        backgroundColor: "#2C633C !important",
        paddingRight: "20px !important",
        paddingLeft: "20px !important",
        height: "40px",
    },
    bottomIconButton: {
        color: "white",
    },
    iconBtn: {
        backgroundColor: "#2C633C !important",
        padding: 0,
        borderRadius: "10px !important",
    },
    addIcon: {
        color: "white",
    },
    inputLabel: {
        fontWeight: "bold !important",
    },
    modal: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        border: "1px solid #000",
        boxShadow: 24,
        padding: "25px !important",
        backgroundColor: "#ebebeb",
        width: "90%",
    },
    table: {
        margin: "25px 0 !important",
        overflow: "scroll",
        backgroundColor: "none !important",
    },
    tableRow: {
        border: "none !important",
    },
    tableCell: {
        padding: "3px !important",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center !important",
    },
    selectBox: {
        backgroundColor: "#ffff",
        width: "125px !important",
        height: "40px !important",
        borderRadius: "5px !important",
    },
    inputBox: {
        width: "40px !important",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#ffff",
        border: "1px solid gray",
        borderTop: "none",
        borderRadius: "0 5px 5px 0 !important",
    },
    playerprofilebtn: {
        backgroundColor: "#06623B !important",
        color: "#FFF !important",
        borderRadius: "5px !important",
        fontWeight: "400 !important",
        minWidth: "150px !important",
        padding: "10px 20px !important",
        textTransform: "capitalize !important",
        "@media (max-width: 780px)": {
            marginTop: "10px !important",
        },
    },
    addBtn: {
        padding: "6px 8px !important",
        minWidth: "20px !important",
    },
}));

var boxRows = [];
for (var i = 1; i <= 20; i++) {
    boxRows.push(i);
}

export default function PlayersList(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const listOfHomeCourses = useSelector((state) => state?.coursesReducer?.data);
    const getMinimalPlayer = useSelector(
        (state) => state?.getMinimalPlayerReducer?.data
    );
    const role = useSelector((state) => state?.userDetailsReducer?.role);
    const [searchVal, setSearchVal] = useState("");

    const [openAddScoreModal, setOpenAddScoreModal] = useState(false);
    const [playerScore, setPlayerList] = useState([]);
    const [downloadCsvData, setDownloadCsvData] = useState([]);
    const [filterPlayer, setFilterPlayer] = useState([]);

    const [listOfAllPlayers, setListOfPlayers] = useState([]);
    const [rowData, setRowData] = useState([
        {
            user_id: "",
            course_id: "",
            user_tee: "",
            score: Array(20).fill(),
        },
    ]);

    const [statusAlert, setStatusAlert] = useState(false);
    const [selectedPlayer, setSelectedPlayer] = useState(null);
    const [deletePlayerConfirmPopup, setDeletePlayerConfirmPopup] = useState(false);

    const onDeletePress = (row) => {
        setSelectedPlayer(row);
        setDeletePlayerConfirmPopup(true);
    }

    const onDelete = () => {
        dispatch(deletePlayer(selectedPlayer._id));
        setDeletePlayerConfirmPopup(false);
        dispatch(getMinimalPlayers(role));
    }

    const handleChangePlayerName = (e, rowIndex, player) => {
        const l_rowData = [...rowData];
        l_rowData[rowIndex].user_id = player._id;
        setRowData(l_rowData);
    };

    const handleUserTeeChange = (e, rowIndex) => {
        const l_rowData = [...rowData];
        const {value} = e.target;
        l_rowData[rowIndex].user_tee = value;
        setRowData(l_rowData);
    };

    const handlehomeCourseChange = (e, rowIndex) => {
        const l_rowData = [...rowData];
        const {value} = e.target;
        l_rowData[rowIndex].course_id = value;
        setRowData(l_rowData);
    };

    const handleChangeScoreValues = (e, cellIndex = 0, rowIndex = 0) => {
        const {value} = e.target;
        var l_row = rowData;
        l_row[rowIndex].score[cellIndex] = parseInt(value);

        setRowData(l_row);
    };

    const handleChangeSearch = (e) => {
        const {value} = e.target;
        setSearchVal(value);

        let list = playerScore.filter((val) => {
            let username = `${val.first_name} ${val.last_name}`;
            return username.toLowerCase().includes(value.toLowerCase());
        });

        setFilterPlayer(list);
    };

    const addRow = (index) => {
        let stateData = [...rowData];
        stateData.push({
            user_id: "",
            course_id: "",
            user_tee: "",
            score: Array(20).fill(0),
        });
        setRowData(stateData);
    };

    const deleteRow = (i) => {
        let l_rowList = [...rowData];
        l_rowList[i] = null;
        setRowData(l_rowList);
    };

    const onSubmitScoreCard = () => {
        const filteredRowData = rowData.filter((x) => {
            return x !== null;
        });

        var data = filteredRowData?.map((item, i) => {
            return {
                user_id: item.user_id,
                course_id: item.course_id,
                user_tee: item.user_tee,
                score: item.score.reverse(),
            };
        });
        var dataObj = {
            score: data,
        };
        dispatch(submitScores(dataObj));
        setOpenAddScoreModal(false);
        setStatusAlert(true);
        setInterval(() => {
            setStatusAlert(false);
        }, 4000);
    };

    const calculateHandicap = () => {
        apiGet(`${ApiEndpoints.user.calculateHandicap}`, (res) => {
            toast.success("Handicap calculation is started");
        });
    };

    useEffect(() => {
        dispatch(getAllCourses());
    }, []);

    useEffect(() => {
        setListOfPlayers(getMinimalPlayer);
    }, [openAddScoreModal]);

    useEffect(() => {
        dispatch(getMinimalPlayers(role));
    }, []);

    useEffect(() => {
        let tempArr = [];
        for (let i = 0; i < playerScore?.length; i++) {
            let tempObj = {
                Name: `${playerScore[i]?.first_name} ${playerScore[i]?.last_name}`,
                WHS: playerScore[i]?.handicap,
                Blue_Tee_HC: playerScore[i]?.tees[0]?.handicap_value,
                White_Tee_HC: playerScore[i]?.tees[1]?.handicap_value,
                Yellow_Tee_HC: playerScore[i]?.tees[2]?.handicap_value,
            };
            tempArr.push(tempObj);
        }
        setDownloadCsvData(tempArr);
    }, [playerScore]);

    return (
        <Grid container sx={{height: "83vh"}}>
            <Grid item xs={12} p={3}>
                <Grid item container sx={{display: "flex", alignItems: "center"}}>
                    <Grid
                        item
                        xs={12}
                        md={4}
                        sx={{
                            display: "flex",
                            alignItem: "center",
                        }}
                        flexDirection={{xs: "column", md: "row"}}
                    >
                        <Typography
                            variant="h5"
                            fontWeight={700}
                            fontSize={{xs: "14px", md: "24px"}}
                        >
                            Players Area
                        </Typography>
                        <Box
                            marginLeft={{xs: 0, md: "20px"}}
                            marginTop={{xs: "10px", md: 0}}
                        >
                            <SearchBar value={searchVal} onChange={handleChangeSearch}/>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={8} marginTop={{xs: "20px", md: 0}}>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                flexWrap: "wrap",
                                alignItems: "flex-end",
                            }}
                        >
                            <Box width={{xs: "100%", sm: "auto"}}>
                                <CSVLink
                                    filename="players-info.csv"
                                    data={downloadCsvData}
                                    style={{
                                        width: "100%",
                                        textDecoration: "none",
                                    }}
                                >
                                    <Button
                                        variant="outlined"
                                        sx={{
                                            padding: "10px",
                                        }}
                                        fullWidth
                                        endIcon={
                                            <img
                                                src={imgCsv}
                                                alt="Download Csv"
                                                width="24px"
                                                height="24px"
                                            />
                                        }
                                    >
                                        Download CSV
                                    </Button>
                                </CSVLink>
                            </Box>

                            {role === "super" && (
                                <>
                                    <Box
                                        width={{xs: "100%", sm: "auto"}}
                                        marginLeft={{xs: "5px", sm: "10px"}}
                                    >
                                        <Button
                                            className={classes.playerprofilebtn}
                                            onClick={() => calculateHandicap()}
                                            fullWidth
                                        >
                                            Update
                                        </Button>
                                    </Box>
                                    <Box
                                        width={{xs: "100%", sm: "auto"}}
                                        marginLeft={{xs: "5px", sm: "10px"}}
                                    >
                                        <Button
                                            className={classes.playerprofilebtn}
                                            onClick={() => setOpenAddScoreModal(true)}
                                            fullWidth
                                        >
                                            Add Scorecard
                                        </Button>
                                    </Box>
                                    <Box
                                        width={{xs: "100%", sm: "auto"}}
                                        marginLeft={{xs: "5px", sm: "10px"}}
                                    >
                                        <Button
                                            className={classes.playerprofilebtn}
                                            onClick={() => {
                                                navigate("/playerRegistration");
                                            }}
                                            fullWidth
                                        >
                                            Add Player
                                        </Button>
                                    </Box>
                                </>
                            )}
                        </Box>
                    </Grid>
                </Grid>
                <Grid item sx={{height: "92%"}}>
                    <Grid container>
                        <Grid item xs={12} marginTop="20px">
                            {statusAlert && (
                                <Alert p={3} severity="success">
                                    Score Card Added Successfully
                                </Alert>
                            )}
                        </Grid>
                        <PlayersListTable
                            setValue={setPlayerList}
                            searchData={filterPlayer}
                            value={searchVal}
                            setSelectedPlayer={setSelectedPlayer}
                            onDeletePress={onDeletePress}
                        />
                    </Grid>
                </Grid>
                {/* ========================= Add Scorecard Modal ========================= */}
                <Grid item container>
                    <Grid item xs={12}>
                        <MainModal
                            show={openAddScoreModal}
                            modalHeadTitle=""
                            closeModal={() => {
                                setOpenAddScoreModal(false);
                            }}
                            btnLeftsx={{display: "none"}}
                            btnRightsx={{display: "none"}}
                        >
                            <Grid container>
                                <Grid item xs={12}>
                                    <Grid
                                        item
                                        container
                                        display={"flex"}
                                        justifyContent={"space-between"}
                                        alignItems={"center"}
                                        mb={1}
                                    >
                                        <Grid
                                            item
                                            xs={11}
                                            sx={{display: "flex", justifyContent: "center"}}
                                        >
                                            <Typography
                                                variant="h6"
                                                sx={{
                                                    textTransform: "uppercase",
                                                    fontWeight: 600,
                                                    margin: "10px 0",
                                                }}
                                                color={"#000000"}
                                            >
                                                Add Scorecard - Bulk Scores
                                            </Typography>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={1}
                                            sx={{display: "flex", justifyContent: "center"}}
                                        >
                                            <IconButton
                                                aria-label="cancel-modal"
                                                onClick={() => setOpenAddScoreModal(false)}
                                            >
                                                <CancelOutlinedIcon/>
                                            </IconButton>
                                        </Grid>
                                    </Grid>

                                    <Divider
                                        orientation="horizontal"
                                        sx={{height: "2px !important"}}
                                    />

                                    <Grid item container xs={12}>
                                        <Grid
                                            item
                                            xs={12}
                                            display={"flex"}
                                            alignItems={"center"}
                                            justifyContent={"center"}
                                        >
                                            <Typography
                                                variant="subtitle1"
                                                fontWeight={500}
                                                marginY={1}
                                                textAlign={"center"}
                                            >
                                                Gross Adjusted Scores - Most recent rounds from 1,
                                                oldest rounds to 20
                                            </Typography>
                                        </Grid>
                                    </Grid>

                                    <Grid item container>
                                        <Grid item xs={12}>
                                            <TableContainer component={Paper}>
                                                <Table
                                                    aria-label="simple table"
                                                    className={classes.table}
                                                >
                                                    <TableHead>
                                                        <TableRow className={classes.tableRow}>
                                                            <TableCell className={classes.tableCell}>
                                                                Player Name
                                                            </TableCell>
                                                            <TableCell className={classes.tableCell}>
                                                                User Tee
                                                            </TableCell>
                                                            <TableCell className={classes.tableCell}>
                                                                Course
                                                            </TableCell>
                                                            {boxRows.map((x, i) => {
                                                                return (
                                                                    <TableCell className={classes.tableCell}>
                                                                        {x}
                                                                    </TableCell>
                                                                );
                                                            })}
                                                        </TableRow>
                                                    </TableHead>

                                                    <TableBody>
                                                        {rowData?.map((row, rowIndex) => {
                                                            if (!row) return;
                                                            return (
                                                                <TableRow className={classes.tableRow}>
                                                                    <TableCell className={classes.tableCell}>
                                                                        <Select
                                                                            variant="outlined"
                                                                            className={classes.outlineInputBorder}
                                                                            placeholder="player name"
                                                                            fullWidth
                                                                            sx={{width: "115px !important"}}
                                                                            label="."
                                                                        >
                                                                            {listOfAllPlayers?.map(
                                                                                (player, index) => {
                                                                                    return (
                                                                                        <MenuItem
                                                                                            onClick={(e) =>
                                                                                                handleChangePlayerName(
                                                                                                    e,
                                                                                                    rowIndex,
                                                                                                    player
                                                                                                )
                                                                                            }
                                                                                            value={player?._id}
                                                                                        >
                                                                                            {`${player?.first_name} ${player.last_name}`}
                                                                                        </MenuItem>
                                                                                    );
                                                                                }
                                                                            )}
                                                                        </Select>
                                                                    </TableCell>

                                                                    <TableCell className={classes.tableCell}>
                                                                        <Select
                                                                            variant="outlined"
                                                                            onChange={(e) =>
                                                                                handleUserTeeChange(e, rowIndex)
                                                                            }
                                                                            className={classes.outlineInputBorder}
                                                                            placeholder="player name"
                                                                            fullWidth
                                                                            sx={{width: "115px !important"}}
                                                                            label="."
                                                                        >
                                                                            <MenuItem value={"blue"}>Blue</MenuItem>
                                                                            <MenuItem value={"white"}>White</MenuItem>
                                                                            <MenuItem value={"yellow"}>
                                                                                Yellow
                                                                            </MenuItem>
                                                                            <MenuItem value={"black"}>
                                                                                Black
                                                                            </MenuItem>
                                                                        </Select>
                                                                    </TableCell>

                                                                    <TableCell className={classes.tableCell}>
                                                                        <Select
                                                                            variant="outlined"
                                                                            onChange={(e) =>
                                                                                handlehomeCourseChange(e, rowIndex)
                                                                            }
                                                                            className={classes.outlineInputBorder}
                                                                            placeholder="player name"
                                                                            fullWidth
                                                                            sx={{width: "115px !important"}}
                                                                            label="."
                                                                        >
                                                                            {listOfHomeCourses &&
                                                                                listOfHomeCourses?.map(
                                                                                    (course, index) => (
                                                                                        <MenuItem value={course?._id}>
                                                                                            {course?.name}
                                                                                        </MenuItem>
                                                                                    )
                                                                                )}
                                                                        </Select>
                                                                    </TableCell>

                                                                    {row?.score.map((x, childIndex) => {
                                                                        return (
                                                                            <TableCell
                                                                                className={classes.tableCell}
                                                                                key={childIndex}
                                                                            >
                                                                                <Box className={classes.inputBox}>
                                                                                    <TextField
                                                                                        onChange={(e) =>
                                                                                            handleChangeScoreValues(
                                                                                                e,
                                                                                                childIndex,
                                                                                                rowIndex
                                                                                            )
                                                                                        }
                                                                                        variant="standard"
                                                                                    />
                                                                                </Box>
                                                                            </TableCell>
                                                                        );
                                                                    })}

                                                                    {rowIndex > 0 ? (
                                                                        <TableCell className={classes.tableCell}>
                                                                            <IconButton
                                                                                onClick={() => deleteRow(rowIndex)}
                                                                                color="error"
                                                                            >
                                                                                <RemoveCircleIcon/>
                                                                            </IconButton>
                                                                        </TableCell>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </TableRow>
                                                            );
                                                        })}
                                                        <TableRow>
                                                            <TableCell className={classes.tableCell}>
                                                                <Button
                                                                    sx={{marginLeft: "15px"}}
                                                                    onClick={() => addRow(i)}
                                                                    variant="contained"
                                                                    className={classes.addBtn}
                                                                >
                                                                    <AddIcon/>
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    </Grid>

                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            mt: "5px",
                                        }}
                                    >
                                        <Button
                                            className={classes.playerprofilebtn}
                                            borderRadius={10}
                                            onClick={onSubmitScoreCard}
                                        >
                                            Save
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </MainModal>
                    </Grid>
                </Grid>
                {/* DELETE MODAL */}
                <MainModal
                    show={deletePlayerConfirmPopup}
                    closeModal={() => setDeletePlayerConfirmPopup(false)}
                    modalHeadTitle="Delete"
                    btnLeftTitle="Ok"
                    btnRightTitle="Cancel"
                    btnCloseModal={() => setDeletePlayerConfirmPopup(false)}
                    leftVariant="outlined"
                    rightVariant="contained"
                    sx={{display: "none"}}
                    width="500px"
                    cb={onDelete}>
                    <Grid item container>
                        <Grid item xs={12} mb={2}>
                            <Stack spacing={1}>
                                <div className={classes.modalDescription}>
                                    <p> Are you sure, you want to Delete?</p>
                                </div>
                            </Stack>
                        </Grid>
                    </Grid>
                </MainModal>
            </Grid>
        </Grid>
    );
}
